module.exports = "/src/views/eternal-dev/businesses/gas-station/images/dark/LimitedLtd/header-background.svg";